<template>
  <div>
    <div v-if="checkSalerUser()">
      <p class="detail-title">{{lang[0]}}</p>
      <b>{{lang[1]}}</b>
      <p class="detail-text buyer_info">{{ name }}</p>
      <b>{{lang[2]}}</b>
      <p class="detail-text buyer_info">{{ postcode }}</p>
      <b>{{lang[3]}}</b>
      <p class="detail-text buyer_info">{{ street }}</p>
      <b>{{lang[4]}}</b>
      <p class="detail-text buyer_info">{{ address }}</p>
      <b>{{lang[5]}}</b>
      <p class="detail-text buyer_info">{{ prefecture }}</p>
      <b>{{lang[6]}}</b>
      <p class="detail-text buyer_info">{{ country }}</p>
    </div>
    <p class="detail-title">{{lang[7]}}</p>
    <p class="detail-text">{{lang[8]}}</p>
    <div class="text-center">
      <btn type="primary" size="normal" :label="lang[9]" @click="confirmShippedModal"></btn>
    </div>
  </div>
</template>

<script>
import Btn from '../components/Button.vue'
import axios from 'axios'
import RequestSalerPhase4LangMaster from '../masters/langMaster/RequestSalerPhase4LangMaster'

export default {
name: 'SalerPhase4',

components:{
  Btn,
  axios
},

data(){
  return {
    name : '',
    postcode : '',
    street : '',
    address : '',
    prefecture : '',
    country : '',
    lang: RequestSalerPhase4LangMaster[this.$store.state.account.lang],
  }
},

props:[
  'buyerId',
  'salerId',
],

mounted() {
  axios.get(`private/request/address_confirm/${this.buyerId}/${this.$route.params.id}`)
  .then((data) => {
    const user = data.data.user
    if (user.country === "Japan") {
      this.name = user.first_name_kanji + user.last_name_kanji
      this.postcode = user.post_code
      this.street = `${user.street_kanji} ${user.line1_kanji} ${user.line2_kanji?user.line2_kanji: ""}`
      this.address = user.address_kanji
      this.prefecture = user.prefecture_kanji
      this.country = user.country
    } else {
      this.name = user.first_name + user.last_name
      this.postcode = user.post_code
      this.street = `${user.street} ${user.line1} ${user.line2? user.line2: ""}`
      this.address = user.address
      this.prefecture = user.prefecture
      this.country = user.country
    }
  }) .catch((err) => {
    console.log(err);
  });
},

methods: {
  confirmShippedModal(){
    this.$parent.confirmShipped = true
  },

  checkSalerUser(){
    if(this.$store.state.account.id === this.salerId){
      return true
    }
  },
}

}

</script>

<style scoped>

.detail-text{
  font-size: 14px;
}

.buyer_info{
  margin-left: 5px;
}

@media screen and (min-width: 800px){

  .detail-title {
    font-size: 18px;
  }

  .detail-text {
    font-size: 16px;
  }
}

</style>
